<template>
  <svg viewBox="0 0 222 232" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M102.073 0L115.384 80.7269H118.477L131.464 0H220.537L177.872 115.37V117.241L220.537 232H131.464L118.477 150.662H115.384L102.073 232H13L55.6659 116.63V114.759L13 0L102.073 0Z"
      fill="currentColor"
    />
  </svg>
</template>
